import { render } from "./EmergencyContactSection.vue?vue&type=template&id=4ce3c6c7"
import script from "./EmergencyContactSection.vue?vue&type=script&lang=js"
export * from "./EmergencyContactSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__